import { render, staticRenderFns } from "./register-v2.vue?vue&type=template&id=d8e3dcb6&scoped=true&"
import script from "./register-v2.vue?vue&type=script&lang=js&"
export * from "./register-v2.vue?vue&type=script&lang=js&"
import style1 from "./register-v2.vue?vue&type=style&index=1&id=d8e3dcb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e3dcb6",
  null
  
)

export default component.exports